import { ReactNode } from 'react';
import { Box } from '@mui/material';

export const TabPanel = ({
  children,
  value,
  tabValue,
}: {
  children?: ReactNode;
  value: number | string;
  tabValue: number | string;
}) => (
  <Box
    role="tabpanel"
    hidden={value !== tabValue}
    id={`tabpanel-${tabValue}`}
    sx={{ marginTop: '15px' }}
  >
    {value === tabValue && <Box>{children}</Box>}
  </Box>
);
